import Card from '@creator/ui/components/Card/CardV2';
import Text from '@creator/ui/components/Text/Text';
import type { FC } from 'react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import PostCardCompact from '../PostCard/PostCardCompact';

export interface ParentPostCardProps {
    parentPostId: string;
    tokenName: string;
    className?: string;
}

const ParentPostCard: FC<ParentPostCardProps> = props => {
    const { parentPostId, tokenName, className = '' } = props;
    const { t } = useTranslation();

    if (!parentPostId || parentPostId === 'root' || parentPostId === 'null') return null;

    return (
        <div className={className}>
            <div className="space-y-2">
                <Text className="block text-sm font-medium">{t('parentPostCard.label')}</Text>
                <Card className="px-4 py-2 rounded-lg">
                    <PostCardCompact postId={parentPostId} tokenName={tokenName} />
                </Card>
            </div>
        </div>
    );
};

export default memo(ParentPostCard);
